// extracted by mini-css-extract-plugin
module.exports = {"actions":"standard_actions__1uTYi","nameLabel":"standard_nameLabel__3WNz9"};